/* eslint-disable no-console */
import React, { useCallback, useEffect, useState } from "react";
import styles from "./styles.module.scss";
import GettingStartedProgress from "app/components/GettingStarted/GettingStartedProgress";
import { cls } from "app/utils";
import { useActions, useSelector } from "app/utils/hooks";
import { deleteTag, clearTags, fetchTagById } from "../../../actions/tag";
import { RootState } from "typedefs";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { shallowEqual } from "react-redux";

const DeleteTag = () => {
  const { t } = useTranslation();
  const { id: tagId } = useParams<{ id: string }>();
  const history = useHistory();
  const tagAction = useActions({ fetchTagById, deleteTag, clearTags });

  const { search } = useLocation();
  const tagsPageUrl = `/account/tags${search}`;

  const route = (path: string) => {
    history.push(path);
  };

  useEffect(() => {
    tagAction.fetchTagById(tagId).catch((err) => {
      console.error(`Something went wrong: ${err}`);
    });
    return () => {
      tagAction.clearTags();
    };
  }, [tagId]);

  const tagState = useSelector((state: RootState) => state.tag, shallowEqual);
  const [deleteallUsages, setDeleteallUsages] = useState(false);

  const submitHandler = useCallback(async () => {
    await tagAction.deleteTag(tagState.selectedTag, deleteallUsages);
    route(tagsPageUrl);
  }, [tagState, deleteallUsages]);

  const checkboxHandler = () => {
    setDeleteallUsages((prev) => !prev);
  };

  return (
    <div className={styles.container}>
      <GettingStartedProgress />
      <div className={styles.add_tag_container}>
        <h1>
          {t("Delete Tag")} &quot;{tagState?.selectedTag?.name}
          &quot;
        </h1>

        <form className={styles.add_new_wrapper}>
          <div className={cls(styles.update_all_usages_wrapper)}>
            <div className={cls("checkbox")}>
              <input
                type="checkbox"
                name="usages"
                id="usages"
                defaultChecked={deleteallUsages}
                onChange={checkboxHandler}
              />
              <label
                htmlFor="usages"
                id="usages"
                className="tag_delete_all"
              ></label>
            </div>
            <label htmlFor="usages">
              {t("delete all occurrences of this tag in my posts")}
            </label>
          </div>
          <span className={styles.buttons_container}>
            <button
              className="btn btn-primary"
              onClick={submitHandler}
              disabled={tagState.pending}
              type="submit"
            >
              <span>
                {tagState.pending ? t("Please Wait...") : t("delete")}
              </span>
            </button>
            <button
              className={cls("btn btn-outline-secondary")}
              onClick={() => route(tagsPageUrl)}
            >
              {t("Cancel")}
            </button>
          </span>
        </form>
      </div>
    </div>
  );
};

export default DeleteTag;
